import { useAbility } from "@casl/react";
import {
  useMutationZapierDisableIntegration,
  useMutationZapierEnableIntegration,
  useQueryZapierGetIntegrationStatus,
} from "@gymflow/api";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { AbilityContext, Subject, Verb } from "../../../../permissions";
import { ModalContext } from "../../../../providers";
import { ApiResolverContext } from "../../../../providers/ApiResolverProvider/ApiResolverContext";
import useGymflowModels from "../../../../store";
import { Button, EyeIcon, Spinner, Switch } from "../../../atoms";
import { IntegrationCard } from "../components/IntegrationCard";
import { ZapierIntegrationModal } from "./ZapierIntegrationModal";

export const ZapierIntegrationCard = () => {
  const ability = useAbility(AbilityContext);
  const { t } = useTranslation();
  const { api } = useGymflowModels();
  const { clubId } = useContext(ApiResolverContext);
  const { setModal } = useContext(ModalContext);
  const { data: dataZapier, isLoading: isLoadingZapier } =
    useQueryZapierGetIntegrationStatus({
      api,
      clubId,
      refetchOnWindowFocus: true,
      enabled: true,
    });

  const { mutateAsync: mutateAsyncEnableZapier } =
    useMutationZapierEnableIntegration({ api });

  const { mutateAsync: mutateAsyncDisableZapier } =
    useMutationZapierDisableIntegration({ api });
  const isZapierEnabled = dataZapier?.status === "ENABLED";

  return (
    <IntegrationCard
      logo={
        <div className="bg-zapier-logo size-10 rounded-lg bg-contain bg-center bg-no-repeat" />
      }
      title={t("components.integrations.zapier.card.title")}
      description={t("components.integrations.zapier.card.description")}
      switchComponent={
        isLoadingZapier ? (
          <Spinner />
        ) : (
          <Switch
            value={isZapierEnabled}
            disabled={!ability.can(Verb.Edit, Subject.ZapierConnect)}
            onChange={async () => {
              if (!dataZapier?.status) {
                return;
              }

              if (isZapierEnabled) {
                await mutateAsyncDisableZapier();
              } else {
                await mutateAsyncEnableZapier();
              }
            }}
          />
        )
      }
      footer={
        ability.can(Verb.Edit, Subject.ZapierConnect) &&
        isZapierEnabled && (
          <Button
            onClick={() => setModal(<ZapierIntegrationModal />)}
            className="h-fit flex-row gap-1 p-0 text-sm hover:opacity-50"
            intent="link-secondary"
          >
            <EyeIcon className="size-5" pathClassName="stroke-secondary-500" />
            {t("components.integrations.zapier.card.viewIntegration")}
          </Button>
        )
      }
    />
  );
};
